import { render, staticRenderFns } from "./trasladoComprobante.vue?vue&type=template&id=3a99046e&scoped=true&"
import script from "./trasladoComprobante.vue?vue&type=script&lang=js&"
export * from "./trasladoComprobante.vue?vue&type=script&lang=js&"
import style0 from "./trasladoComprobante.vue?vue&type=style&index=0&id=3a99046e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a99046e",
  null
  
)

export default component.exports